import { Fragment } from "react/jsx-runtime";
import { socketActions } from "../../../../store/socketSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import ActionIcon from "../../../ui/action-icon/ActionIcon";
import "./MainStatusBar.scss";
import ConnectionIndicator from "./components/connection-indicator/ConnectionIndicator";
import Tooltip from "../../../ui/tooltip/Tooltip";

const MainStatusBar = () => {
  const dispatch = useAppDispatch();
  const isConnected = useAppSelector((s) => s.socket.isConnected);

  const selfTv = () => dispatch(socketActions.sendMessage("selftv"));
  const selfFollow = () => dispatch(socketActions.sendMessage("followSelf"));

  return (
    <div className="main-status-bar">
      <div className="primary">
        <ConnectionIndicator />
      </div>
      <div className="secondary">
        {isConnected && (
          <Fragment>
            <Tooltip text="Spectate" position="bottom">
            <ActionIcon
              icon="fa-solid fa-arrows-to-eye darken-white"
              onClick={selfTv}
            />
            </Tooltip>
            <Tooltip text="Focus" position="bottom">
            <ActionIcon
              icon="fa-solid fa-location-crosshairs darken-white"
              onClick={selfFollow}
            />
            </Tooltip>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default MainStatusBar;
